import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { Spaces } from '@ff-os/rendering-shared/coordinates';
import { AspectRatio } from '@ff-os/shared-react/components/aspect-ratio/AspectRatio';
import { Translate } from '@ff-os/shared-utils/types/Translate';
import { Prefab } from '@ff-resource-plugins/prefabs-shared/Prefab';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { Paintable } from 'ff-canvas';
import { selectPaintablesForPrefabPreviewById, selectPrefabViewboxById } from '../_redux-prefabs';
import { createMinimalPreviewSpaces } from './helpers/createMinimalPreviewSpaces';
import { Preview2d } from './Preview2d';

const _MinimalPrefabPreview2d = ({ paintables, spaces }: Props) => (
    <AspectRatio width={spaces.sceneWidth} height={spaces.sceneHeight}>
        <Preview2d paintables={paintables} spaces={spaces} />
    </AspectRatio>
);

type Props = {
    paintables: Paintable[];
    spaces: Spaces;
};

const mapStateToProps = (
    state: GiftPdpState,
    ownProps: { prefab: Prefab; t: Translate }
) => ({
    paintables: selectPaintablesForPrefabPreviewById(state, ownProps.prefab.id, ownProps.t),
    spaces: selectSpacesForMinimalPrefabPreviewById(state, ownProps.prefab.id)
});

export const MinimalPrefabPreview2d = connect(
    mapStateToProps
)(_MinimalPrefabPreview2d);

const selectSpacesForMinimalPrefabPreviewById = createSelector([
    (state: GiftPdpState, prefabId: string) => selectPrefabViewboxById(state, prefabId)
], createMinimalPreviewSpaces);